/*
export interface Suggestion {
    text: string;
    placeId: string;
}

export interface Place {
    address: {
        city: string;
        country: string;
    };

    coordinates: {
        longitude: string;
        latitude: string;
    };
}
*/

export class GeocodeAPI {
    /**
     * @param baseUrl   The API's base URL
     * @param token     The API's authorization token
     */
    constructor(baseUrl, token) {
        this.baseUrl = baseUrl;
        this.token = token;
    }

    /**
     * Map of endpoint URL generators used by this API client
     * @private
     */
    endpoints = {
        suggestions: (query, language, token) =>
            `${this.baseUrl}/suggestions?q=${encodeURIComponent(query)}&l=${encodeURIComponent(language)}&t=${encodeURIComponent(token)}`,
        place: (placeId, language, token) =>
            `${this.baseUrl}/place?id=${encodeURIComponent(placeId)}&l=${encodeURIComponent(language)}&t=${encodeURIComponent(token)}`,
    };

    /**
     * Get location autocomplete suggestions
     * @param text string
     * @param language string
     * @param token string
     * @return Promise<Suggestion[]>
     */
    async getSuggestions(text, language, token) {
        const res = await this.apiRequest(this.endpoints.suggestions(text, language, token));
        return await res.json();
    }

    /**
     * Get details of a place
     * @param placeId string
     * @param language string
     * @param token string
     * @return Promise<Place>
     */
    async getPlace(placeId, language, token) {
        const res = await this.apiRequest(this.endpoints.place(placeId, language, token));
        return await res.json();
    }

    /**
     * Perform an API request including common parameters (e.g. Authorization header)
     * @private
     */
    async apiRequest(url) {
        const options = {
            headers: {
                'Authorization': `Bearer ${this.token}`
            }
        };
        return await fetch(url, options);
    }
}
